import React, { useState } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { Text } from '@atlaskit/primitives/compiled';
import { N20 } from '@atlaskit/theme/colors';
import Toggle from '@atlaskit/toggle';
export const ErrorSection = ({
  errorDetails
}) => {
  const [showErrorDetails, setShowErrorDetails] = useState(false);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ErrorSectionLabel, null, /*#__PURE__*/React.createElement(Text, {
    as: "p"
  }, "Show error details:"), /*#__PURE__*/React.createElement(Toggle, {
    isChecked: showErrorDetails,
    onChange: () => {
      setShowErrorDetails(!showErrorDetails);
    }
  })), showErrorDetails && /*#__PURE__*/React.createElement(ErrorDetailsWrapper, null, /*#__PURE__*/React.createElement("code", null, errorDetails)));
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ErrorSectionLabel = styled.div({
  display: 'flex',
  marginTop: "var(--ds-space-250, 20px)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '> p': {
    marginTop: "var(--ds-space-025, 2px)"
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ErrorDetailsWrapper = styled.div({
  backgroundColor: `var(--ds-background-neutral, ${N20})`,
  padding: "var(--ds-space-100, 8px)",
  font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});